export enum SmartTableToolName {
  CREATE_SMART_TABLE = "create_smart_table",
  UPDATE_SMART_TABLE = "update_smart_table",
  DELETE_SMART_TABLE = "delete_smart_table",
  LIST_SMART_TABLE_SHEETS = "list_smart_table_sheets",
  CREATE_SMART_TABLE_SHEET = "create_smart_table_sheet",
  UPDATE_SMART_TABLE_SHEET = "update_smart_table_sheet",
  DELETE_SMART_TABLE_SHEET = "delete_smart_table_sheet",
  GET_SMART_TABLE_GRID = "get_smart_table_grid",
  CREATE_SMART_TABLE_COLUMN = "create_smart_table_column",
  UPDATE_SMART_TABLE_COLUMN = "update_smart_table_column",
  DELETE_SMART_TABLE_COLUMN = "delete_smart_table_column",
  ADD_SMART_TABLE_ROWS = "add_smart_table_rows",
  DELETE_SMART_TABLE_ROWS = "delete_smart_table_rows",
  UPDATE_SMART_TABLE_CELL = "update_smart_table_cell",
  IMPORT_SMART_TABLE_REQUEST_HISTORY = "import_smart_table_request_history",
  RUN_SMART_TABLE = "run_smart_table",
  CONFIGURE_SMART_TABLE_SCORE = "configure_smart_table_score",
  CONFIGURE_SMART_TABLE_SCORECARD = "configure_smart_table_scorecard",
  GET_SMART_TABLE_SCORECARD = "get_smart_table_scorecard",
  RECALCULATE_SMART_TABLE_SCORECARD = "recalculate_smart_table_scorecard",
}

export type SmartTableVibeRefreshScope = "tableStructure" | "sheetColumns" | "sheetRows" | "score";

export const normalizeSmartTableToolName = (toolName: string): string =>
  toolName.trim().toLowerCase();

export const getSmartTableVibeRefreshScope = (
  toolName: string,
): SmartTableVibeRefreshScope | null => {
  switch (normalizeSmartTableToolName(toolName)) {
    case SmartTableToolName.CREATE_SMART_TABLE:
    case SmartTableToolName.CREATE_SMART_TABLE_SHEET:
    case SmartTableToolName.UPDATE_SMART_TABLE_SHEET:
    case SmartTableToolName.DELETE_SMART_TABLE_SHEET:
      return "tableStructure";
    case SmartTableToolName.CREATE_SMART_TABLE_COLUMN:
    case SmartTableToolName.UPDATE_SMART_TABLE_COLUMN:
    case SmartTableToolName.DELETE_SMART_TABLE_COLUMN:
      return "sheetColumns";
    case SmartTableToolName.ADD_SMART_TABLE_ROWS:
    case SmartTableToolName.DELETE_SMART_TABLE_ROWS:
    case SmartTableToolName.UPDATE_SMART_TABLE_CELL:
    case SmartTableToolName.IMPORT_SMART_TABLE_REQUEST_HISTORY:
      return "sheetRows";
    case SmartTableToolName.CONFIGURE_SMART_TABLE_SCORE:
    case SmartTableToolName.CONFIGURE_SMART_TABLE_SCORECARD:
    case SmartTableToolName.RECALCULATE_SMART_TABLE_SCORECARD:
      return "score";
    default:
      return null;
  }
};

/** Sheet-level AG Grid cache refresh is handled by the mounted Table page listener. */
export const shouldPublishSmartTableVibeGridRefresh = (
  scope: SmartTableVibeRefreshScope | null,
  sheetId: string | undefined,
): boolean => {
  if (!scope || scope === "tableStructure") {
    return false;
  }

  return Boolean(sheetId);
};

export const isSmartTableToolInGroup = (
  toolName: string,
  group: Record<string, SmartTableToolName>,
): boolean => (Object.values(group) as string[]).includes(normalizeSmartTableToolName(toolName));
